import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiVisa, BasicApiResponseModel, Core2Config } from '../../shared';
import { SysAdminModel } from '../../../../../../models/aggregates/sysAdmin/app-system-adminstrator.model';

@Injectable({
  providedIn: 'root',
})
export class SysAdminService extends BaseApiTemplateService<SysAdminModel>{
  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'sysadmin';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'sysadmin';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'sysadmin';
    this.httpClient = http;
  }

  deleteSysadmin(linkGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + linkGuid;
    }
    return this.httpClient.delete(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  getAllSysadmin(apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  getByGuidSysadmin(linkGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/' + linkGuid;
    }
    return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  checkUserByEmailForSysAdmin(email: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + '/user/sysadmin-ep?email=' + email;
    }
    return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
  }


  // /core2/platform/dm/iam/user-invitation/send-invite/sysadmin-ep
  sendInviationtoJoinAsSysadmin(request: any, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.IAM_PREFIX + "user-invitation/send-invite/sysadmin-ep";
    }

    return this.httpClient.post(this.apiUrl, request, this.getHttpHeader(apiVisa));
  }
}
